import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "../scss/Common.scss";
import Header from "../components/Header";

export default function Home() {
  let storage = sessionStorage;

  const [isContentWidthSet, setIsContentWidthSet] = useState(false);
  useEffect(() => {
    if (!isContentWidthSet) {
      if (window.innerWidth < 800) {
        // 처음에 한번만 width를 세팅하도록 한다.
        setIsContentWidthSet(true);
        storage.setItem("contentWidth", window.innerWidth.toString());
      } else {
        setIsContentWidthSet(true);
        storage.setItem("contentWidth", "800");
      }
    }
  }, []);
  const contentWidth = Number(storage.getItem("contentWidth"));
  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
      }}
    >
      <Header />
      <div className="title">Opticon's Tasks</div>
      <p className="content">
        1. 기획에서 현장까지 관통하는 효율적인 설계 자동화 시스템을 구축한다.
        <br />
        2. 건축설계와 IT 기술 사이의 연구를 수행하고 현업에 활용한다.
        <br />
        3. 소비자 측에서 매력적인 건축 서비스와 건축 상품을 제안하고 사업화한다.
      </p>

      <div className="title">이신후</div>
      <div className="content">
        Opticon 대표 <br />
        이화여자대학교 건축공간의 분석 강사
        <br />
        <br />
        2011 ~ 2019 서울대학교 건축학과 건축학전공 수석졸업 <br />
        서울대학교 미술대학 조소과, 디자인학부 금속공예과 부전공
        <br />
        <br />
        2019 ~ 2021 솔토지빈 건축사사무소 <br />
        - 염곡동 단독주택
        <br /> - 마산교구청사
        <br /> - 세종시 산림청사
        <br />
        <br />
        2021 ~ 2023 제너레잇
        <br /> - LA Multifamily Housing 자동화 기획 구현
        <br />
        <br />
        2023 ~ 2024 에디트 콜렉티브 <br />
        - 일반 상업지역 공동주택 설계 자동화 기획 구현
        <br />
        - 일반 주거지역 공동주택 설계 자동화 기획 구현
        <br />
        <br />
        2023 ~ 정림재단 컴퓨테이셔널 강연 및 워크샵
        <br />
        <br />
      </div>
      <div className="content">
        워크샵 혹은 설계자동화 관련 커피챗과 프로젝트 문의는 언제나 환영합니다.
        <br />
        Email 로 연락주시면 1~2일 정도 안으로 답변 가능합니다. <br />
        <br />
        Email : opticon.master@gmail.com
        <br />
        Phone : 01072477712
      </div>
    </div>
  );
}
